import React, { useMemo, useState } from "react";
import PageShell from "../components/layout/PageShell";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Formations() {
  useScrollReveal();
  const [tab, setTab] = useState("initiale");

  const tracks = useMemo(
    () => [
      {
        title: "Fonction Paix",
        items: [
          { label: "Fonction Paix (civil)", hours: 20, teacher: "Durin Duret Junior" },
          { label: "Fonction Paix (pénal)", hours: 20, teacher: "Eno René Louis" },
          {
            label: "Exercices pratiques / simulation d'audience",
            hours: 20,
            teacher: "Durin Duret Junior / Eno René Louis",
          },
        ],
      },
      {
        title: "Fonction Parquet",
        items: [
          { label: "Fonction Parquet", hours: 20, teacher: "Mag. Frantzi Philemon" },
          {
            label: "Techniques de rédaction de réquisitoire",
            hours: 20,
            teacher: "Mag. Frantz Poteau",
          },
          {
            label: "Les fonctions civiles du Parquet",
            hours: 20,
            teacher: "Mag. Loubens Elysée",
          },
        ],
      },
      {
        title: "Fonction Instruction",
        items: [
          { label: "Fonction Instruction", hours: 20, teacher: "Mag. Gabrielle D. Pierre" },
          {
            label: "Techniques de rédaction d'ordonnance",
            hours: 10,
            teacher: "Mag. Gabrielle D. Pierre",
          },
          {
            label: "Exercices pratiques / simulation d'audience",
            hours: 20,
            teacher: "—",
          },
        ],
      },
      {
        title: "Fonction Siège",
        items: [
          { label: "Fonction Siège", hours: 20, teacher: "Mag. Maguy Florestal" },
          {
            label: "Exercices pratiques / simulation d'audience",
            hours: 20,
            teacher: "Mag. André Saint-Isert",
          },
          {
            label: "Méthodologie de la rédaction de jugement",
            hours: 20,
            teacher: "Mag. Maguy Florestal",
          },
        ],
      },
      {
        title: "Fonction Enfant",
        items: [
          {
            label: "Fonction Enfant",
            hours: 20,
            teacher: "Mag. Norah A. Jean-François / Mag. Emmanuel Lacroix",
          },
          {
            label: "Exercices pratiques / simulation d'audience",
            hours: 20,
            teacher: "—",
          },
        ],
      },
    ],
    []
  );

  const modulesTransversaux = useMemo(
    () => [
      { label: "Mise à niveau Droit civil et procédure civile", hours: 20, teacher: "Me Eugène Pierre-Louis" },
      { label: "Mise à niveau Droit pénal et procédure pénale", hours: 20, teacher: "Mag. Frantz Drice" },
      { label: "Commentaires d'arrêt", hours: 10, teacher: "Me Evens Fils" },
      { label: "Contentieux commercial", hours: 20, teacher: "Me Fabrice Fièvre" },
      { label: "Contentieux du travail", hours: 20, teacher: "Mag. Julio Elisna" },
      { label: "Droits fondamentaux et droits de l'Homme", hours: 20, teacher: "Dr Patrick Pelissier" },
      { label: "Éthique et Déontologie", hours: 30, teacher: "Me Sabine Boucher" },
      { label: "Expression créole / Expression française", hours: 20, teacher: "Mag. Loubens Elysée" },
      { label: "Infractions économiques et financières", hours: 30, teacher: "Mag. Yves Altidor" },
      { label: "Introduction aux droits des femmes", hours: 20, teacher: "Me Ketleine Charles" },
      { label: "L'administration du Greffe", hours: 10, teacher: "Me John Vivaldi Louis" },
      { label: "La Communication Judiciaire", hours: 10, teacher: "Mag. Wando Saint-Villier" },
      { label: "La cybercriminalité", hours: 20, teacher: "Me Blair Chery" },
      { label: "La Juridiction des Référés", hours: 10, teacher: "Mag. Bernard Saint-Vil" },
      { label: "La place de la victime dans la procédure pénale", hours: 10, teacher: "Me Jacques Letang" },
      { label: "Le contentieux des loyers", hours: 20, teacher: "Me Gabriel Nerette" },
      { label: "Le contentieux du divorce / de la vente", hours: 10, teacher: "Mag. Ketsia Charles" },
      { label: "Le contentieux rural", hours: 20, teacher: "Mag. Grecia Norceus" },
      { label: "Le Management judiciaire", hours: 20, teacher: "Gracia Josel S. Maxi" },
      { label: "Le raisonnement juridique", hours: 20, teacher: "Me Camille Fièvre" },
      { label: "Crimes / infractions pénales internationales", hours: 20, teacher: "Prof. James Boyard" },
      { label: "Médecine légale", hours: 20, teacher: "Docteur Armel Demorcy" },
      { label: "Méthodes gracieuses de résolution de conflits", hours: 20, teacher: "Mag. Carvès Jean" },
      { label: "Langue et accès à la justice en Haïti", hours: 20, teacher: "Prof. Fritz Deshommes" },
      { label: "Introduction aux TICE", hours: 20, teacher: "Prof. Judith St Surin" },
      {
        label: "Techniques d'investigation / audition / interrogatoire",
        hours: 20,
        teacher: "Mag. Jean-Claude Marthel",
      },
      { label: "Organisation Judiciaire", hours: 20, teacher: "Jean-Claude Theogene" },
    ],
    []
  );

  const calendrier = useMemo(
    () => [
      { date: "Juillet 2025", label: "Appel à candidature", lieu: "—" },
      {
        date: "11–22 août 2025",
        label: "Examen écrit / publication des résultats",
        lieu: "École de la Magistrature",
      },
      {
        date: "29 août 2025",
        label: "Publication de la liste d'admissibilité",
        lieu: "École de la Magistrature",
      },
      {
        date: "11–12 sept. 2025",
        label: "Épreuves écrites du concours",
        lieu: "École de la Magistrature",
      },
      {
        date: "26 sept. 2025",
        label: "Liste des postulants habilités à passer le grand oral",
        lieu: "École de la Magistrature",
      },
      {
        date: "Octobre 2025",
        label: "Épreuves orales / examens psychologiques / liste des admis-es",
        lieu: "École de la Magistrature",
      },
      {
        date: "3–7 nov. 2025",
        label: "Accueil des élèves-magistrats (semaine d'immersion)",
        lieu: "École de la Magistrature",
      },
      {
        date: "17 nov. – 19 déc. 2025",
        label: "Stage d'observation dans les juridictions",
        lieu: "Tribunaux de Paix, TPI, Parquet, Instruction, Tribunal pour enfant",
      },
      { date: "12 janv. – 27 mars 2026", label: "Cours à l'EMA", lieu: "École de la Magistrature" },
      { date: "30 mars – 10 avril 2026", label: "Vacances de Pâques", lieu: "—" },
      { date: "13 avril – 26 juin 2026", label: "Cours à l'EMA", lieu: "École de la Magistrature" },
      {
        date: "6 – 31 juillet 2026",
        label: "Stages en juridiction",
        lieu: "Tribunaux de Paix, TPI, Parquet, Instruction, Tribunal pour enfant",
      },
      { date: "3 – 28 août 2026", label: "Vacances d'été", lieu: "—" },
      {
        date: "31 août – 18 déc. 2026",
        label: "Stages en juridiction",
        lieu: "Tribunaux de Paix, TPI, Parquet, Instruction, Tribunal pour enfant",
      },
      {
        date: "11 – 15 janv. 2027",
        label: "Regroupement à l'EMA : rapport de stage, cas pratiques, préparation des examens",
        lieu: "École de la Magistrature",
      },
      { date: "18 – 22 janv. 2027", label: "Épreuves écrites", lieu: "École de la Magistrature" },
      { date: "25 – 29 janv. 2027", label: "Épreuves orales", lieu: "École de la Magistrature" },
      { date: "Vendredi 12 mars 2027", label: "Graduation", lieu: "École de la Magistrature" },
    ],
    []
  );

  const biosProfesseurs = useMemo(
    () => ({
      "Com. Mikerlange Louis-Jeune": "Intervenante en infractions routières et sécurité de la circulation.",
      "Docteur Armel Demorcy": "Formateur en médecine légale et analyse médico-judiciaire.",
      "Dr Patrick Pelissier": "Spécialiste des droits fondamentaux et des droits de l'Homme.",
      "Durin Duret Junior": "Formateur en fonction Paix et en exercices pratiques d'audience.",
      "Eno René Louis": "Intervenant en fonction Paix (pénal) et mises en situation d'audience.",
      "Gracia Josel S. Maxi": "Formateur en management judiciaire et organisation institutionnelle.",
      "Jean-Claude Theogene": "Intervenant en organisation judiciaire et fonctionnement des juridictions.",
      "Mag. André Saint-Isert": "Magistrat formateur en simulations d'audience et pratique du siège.",
      "Mag. Bernard Saint-Vil": "Intervenant sur les référés et la procédure en habeas corpus.",
      "Mag. Carvès Jean": "Spécialiste des méthodes gracieuses de résolution de conflits.",
      "Mag. Frantzi Philemon": "Magistrat formateur en fonction Parquet.",
      "Mag. Frantz Drice": "Formateur en droit pénal et procédure pénale.",
      "Mag. Frantz Poteau": "Intervenant en techniques de rédaction de réquisitoire.",
      "Mag. Gabrielle D. Pierre": "Magistrate spécialisée en fonction Instruction et rédaction d'ordonnance.",
      "Mag. Jean-Claude Marthel": "Formateur en techniques d'investigation, d'audition et d'interrogatoire.",
      "Mag. Julio Elisna": "Intervenant en contentieux du travail.",
      "Mag. Ketsia Charles": "Intervenante en contentieux du divorce et de la vente.",
      "Mag. Loubens Elysée": "Magistrat formateur en expression juridique et fonctions civiles du parquet.",
      "Mag. Maguy Florestal": "Magistrate formatrice en fonction Siège et rédaction de jugement.",
      "Mag. Norah A. Jean-François": "Intervenante en justice des mineurs et protection de l'enfance.",
      "Mag. Wando Saint-Villier": "Formateur en communication judiciaire.",
      "Mag. Yves Altidor": "Intervenant en infractions économiques et financières.",
      "Me Blair Chery": "Avocat formateur en cybercriminalité.",
      "Me Camille Fièvre": "Intervenant en raisonnement juridique et argumentation.",
      "Me Eugène Pierre-Louis": "Formateur en droit civil et procédure civile.",
      "Me Evens Fils": "Intervenant en commentaires d'arrêt et analyse jurisprudentielle.",
      "Me Fabrice Fièvre": "Formateur en contentieux commercial.",
      "Me Gabriel Nerette": "Intervenant en contentieux des loyers.",
      "Me Jacques Letang": "Formateur sur la place de la victime dans la procédure pénale.",
      "Me John Vivaldi Louis": "Intervenant en administration du greffe.",
      "Me Ketleine Charles": "Formatrice en introduction aux droits des femmes.",
      "Me Sabine Boucher": "Intervenante en éthique et déontologie.",
      "Prof. Fritz Deshommes": "Professeur d'économie, ancien recteur de l'UEH (2016-2025), spécialiste en développement économique.",
      "Prof. Judith St Surin": "Professeure en pédagogie universitaire et spécialiste en intégration du numérique dans l'enseignement supérieur.",
      "Prof. James Boyard": "Professeur intervenant sur les crimes et infractions pénales internationales.",
    }),
    []
  );

  const profs = useMemo(() => {
    const map = new Map();

    const add = (name, tags = []) => {
      if (!name || name === "—") return;

      name
        .split("/")
        .map((s) => s.trim())
        .forEach((n) => {
          if (!n) return;
          const key = n.toLowerCase();
          const prev = map.get(key) || { name: n, tags: new Set() };
          tags.forEach((t) => prev.tags.add(t));
          map.set(key, prev);
        });
    };

    tracks.forEach((t) => t.items.forEach((it) => add(it.teacher, [t.title])));
    modulesTransversaux.forEach((m) => add(m.teacher, ["Modules transversaux"]));

    return Array.from(map.values())
      .map((x) => ({
        name: x.name,
        tags: Array.from(x.tags),
        bio: biosProfesseurs[x.name] || "Biographie à compléter.",
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [tracks, modulesTransversaux, biosProfesseurs]);

  return (
    <PageShell
      title="Formations"
      subtitle="Programmes de formation de l'École de la Magistrature"
    >
      {/* Vue d'ensemble rapide */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, rgba(11,44,95,0.04) 0%, rgba(212,175,55,0.04) 100%)',
        borderRadius: '20px',
        padding: '32px',
        marginBottom: '32px',
        border: '1px solid rgba(11,44,95,0.08)'
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', textAlign: 'center' }}>
          <div>
            <div style={{ fontSize: '32px', fontWeight: 900, color: '#0B2C5F' }}>5</div>
            <div style={{ fontSize: '13px', color: '#6B7280', fontWeight: 600 }}>Parcours métiers</div>
          </div>
          <div>
            <div style={{ fontSize: '32px', fontWeight: 900, color: '#0B2C5F' }}>26</div>
            <div style={{ fontSize: '13px', color: '#6B7280', fontWeight: 600 }}>Modules transversaux</div>
          </div>
          <div>
            <div style={{ fontSize: '32px', fontWeight: 900, color: '#D4AF37' }}>30+</div>
            <div style={{ fontSize: '13px', color: '#6B7280', fontWeight: 600 }}>Formateurs experts</div>
          </div>
          <div>
            <div style={{ fontSize: '32px', fontWeight: 900, color: '#0B2C5F' }}>18</div>
            <div style={{ fontSize: '13px', color: '#6B7280', fontWeight: 600 }}>Mois de formation</div>
          </div>
        </div>
      </section>

      {/* Actions */}
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
        <a
          className="ema-btn ema-btn-secondary"
          href="/documents/Formation Initiale.pdf"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none' }}
        >
          Télécharger Programme de formation
        </a>

        <a
          className="ema-btn ema-btn-ghost"
          href="https://moodle.ema.edu.ht"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none' }}
        >
          Campus numérique (Moodle)
        </a>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '32px', borderBottom: '2px solid #e5e7eb', paddingBottom: '0' }}>
        <Tab active={tab === "initiale"} onClick={() => setTab("initiale")}>
          Formation initiale
        </Tab>
        <Tab active={tab === "probatoire"} onClick={() => setTab("probatoire")}>
          Formation probatoire
        </Tab>
        <Tab active={tab === "continue"} onClick={() => setTab("continue")}>
          Formation continue
        </Tab>
        <Tab active={tab === "modules"} onClick={() => setTab("modules")}>
          Modules
        </Tab>
        <Tab active={tab === "seminaires"} onClick={() => setTab("seminaires")}>
          Séminaires
        </Tab>
        <Tab active={tab === "calendrier"} onClick={() => setTab("calendrier")}>
          Calendrier
        </Tab>
        <Tab active={tab === "professoral"} onClick={() => setTab("professoral")}>
          Corps professoral
        </Tab>
      </div>

      {tab === "initiale" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #0B2C5F, #1e40af)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Formation initiale</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>18 mois • Concours d'entrée requis • 5 parcours métiers</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '24px' }}>
            La formation initiale est destinée aux candidats admis au concours d'entrée à l'École
            de la Magistrature. Elle combine enseignements théoriques, simulations d'audience et
            stages pratiques au sein des juridictions.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '20px' }}>
            {tracks.map((track, trackIdx) => {
              const colors = ['#0B2C5F', '#1e40af', '#7c3aed', '#D4AF37', '#059669'];
              const color = colors[trackIdx % colors.length];
              const totalHours = track.items.reduce((sum, it) => sum + it.hours, 0);
              return (
                <div key={track.title} style={{
                  background: '#fff',
                  border: '1px solid #e5e7eb',
                  borderTop: `4px solid ${color}`,
                  borderRadius: '16px',
                  padding: '24px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                  transition: 'all 0.3s ease'
                }}
                  onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)'; }}
                  onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)'; }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={{ fontSize: '17px', fontWeight: 700, color: color, margin: 0 }}>{track.title}</h3>
                    <span style={{ background: `${color}12`, color: color, padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: 700 }}>{totalHours}h</span>
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {track.items.map((it, idx) => (
                      <li key={idx} style={{ padding: '12px 0', borderBottom: idx < track.items.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '14px', marginBottom: '4px' }}>{it.label}</div>
                            <div style={{ fontSize: '12px', color: '#9CA3AF', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                              {it.teacher}
                            </div>
                          </div>
                          <span style={{ fontSize: '12px', fontWeight: 700, color: '#6B7280', whiteSpace: 'nowrap' }}>{it.hours}h</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </section>
      )}

      {tab === "probatoire" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #7c3aed, #a855f7)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6"/><path d="M23 11h-6"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Formation probatoire</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>Magistrats nouvellement nommés • Accompagnement à la prise de fonction</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '28px' }}>
            La formation probatoire s'adresse aux magistrats nouvellement nommés. Elle vise à
            consolider leurs compétences professionnelles et à faciliter leur intégration dans
            l'exercice des fonctions juridictionnelles.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            <div style={{ background: 'linear-gradient(135deg, #0B2C5F 0%, #1e3a6e 100%)', borderRadius: '16px', padding: '28px', color: '#fff' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              <h3 style={{ fontSize: '16px', fontWeight: 700, marginBottom: '12px' }}>Objectifs</h3>
              <p style={{ fontSize: '14px', opacity: 0.85, lineHeight: 1.6 }}>
                Renforcer les bases professionnelles, l'éthique judiciaire et la maîtrise des
                pratiques indispensables à l'exercice des fonctions.
              </p>
            </div>

            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', padding: '28px', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginBottom: '16px' }}>Contenus</h3>
              {['Rédaction de jugement', 'Conduite d\'audience', 'Déontologie judiciaire', 'Organisation judiciaire'].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0', borderBottom: i < 3 ? '1px solid #f3f4f6' : 'none' }}>
                  <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#7c3aed', flexShrink: 0 }} />
                  <span style={{ fontSize: '14px', color: '#374151', fontWeight: 500 }}>{item}</span>
                </div>
              ))}
            </div>

            <div style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.08) 0%, rgba(11,44,95,0.04) 100%)', border: '1px solid rgba(212,175,55,0.2)', borderRadius: '16px', padding: '28px' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginBottom: '12px' }}>Approche pédagogique</h3>
              <p style={{ fontSize: '14px', color: '#374151', lineHeight: 1.6 }}>
                Mise en situation, études de cas, supervision professionnelle et accompagnement
                à la prise de fonction par des magistrats expérimentés.
              </p>
            </div>
          </div>
        </section>
      )}

      {tab === "continue" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #059669, #10b981)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Formation continue</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>Perfectionnement • Magistrats en exercice • Sessions spécialisées</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '28px' }}>
            La formation continue permet aux magistrats, greffiers et professionnels de la Justice
            d'actualiser leurs connaissances et d'approfondir leurs compétences face aux évolutions
            du droit et des pratiques judiciaires.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '20px' }}>
            {/* Thématiques */}
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', padding: '28px', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' }}>
              <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginBottom: '20px' }}>Thématiques prioritaires</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                {['Cybercriminalité', 'Infractions économiques', 'Droits humains', 'Justice des mineurs', 'Contentieux foncier', 'Violences basées sur le genre'].map((topic, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f9fafb', borderRadius: '10px', border: '1px solid #f3f4f6' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#059669', flexShrink: 0 }} />
                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>{topic}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Info cards */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ background: 'linear-gradient(135deg, #059669, #10b981)', borderRadius: '16px', padding: '24px', color: '#fff', flex: 1 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '12px' }}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                <h4 style={{ fontSize: '14px', fontWeight: 700, marginBottom: '6px' }}>Public cible</h4>
                <p style={{ fontSize: '13px', opacity: 0.9, lineHeight: 1.5 }}>Magistrats, greffiers et professionnels de la Justice</p>
              </div>
              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 16px rgba(0,0,0,0.04)', flex: 1 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '12px' }}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#0B2C5F', marginBottom: '6px' }}>Format</h4>
                <p style={{ fontSize: '13px', color: '#6B7280', lineHeight: 1.5 }}>Séminaires, ateliers pratiques et sessions spécialisées</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {tab === "modules" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #D4AF37, #f4d03f)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b3b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Modules transversaux</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>{modulesTransversaux.length} modules • Compétences essentielles • Tous parcours</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '24px' }}>
            Les modules transversaux complètent les parcours métiers en développant des
            compétences essentielles : raisonnement juridique, rédaction judiciaire,
            déontologie, droits fondamentaux et techniques d'investigation.
          </p>

          {/* Table header */}
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.2fr 80px', gap: '12px', padding: '16px 24px', background: 'linear-gradient(135deg, #0B2C5F, #1e3a6e)', color: '#fff', fontWeight: 700, fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              <div>Module</div>
              <div>Formateur</div>
              <div style={{ textAlign: 'right' }}>Heures</div>
            </div>

            {modulesTransversaux.map((m, idx) => (
              <div key={idx} style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1.2fr 80px',
                gap: '12px',
                padding: '14px 24px',
                borderBottom: idx < modulesTransversaux.length - 1 ? '1px solid #f3f4f6' : 'none',
                transition: 'background 0.2s',
                cursor: 'default'
              }}
                onMouseOver={(e) => e.currentTarget.style.background = '#f9fafb'}
                onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '14px' }}>{m.label}</div>
                <div style={{ fontSize: '13px', color: '#6B7280' }}>{m.teacher}</div>
                <div style={{ textAlign: 'right' }}>
                  <span style={{ background: 'rgba(11,44,95,0.08)', color: '#0B2C5F', padding: '4px 10px', borderRadius: '100px', fontSize: '12px', fontWeight: 700 }}>{m.hours}h</span>
                </div>
              </div>
            ))}

            {/* Total */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.2fr 80px', gap: '12px', padding: '16px 24px', background: '#f9fafb', borderTop: '2px solid #e5e7eb' }}>
              <div style={{ fontWeight: 800, color: '#0B2C5F', fontSize: '14px' }}>Total</div>
              <div></div>
              <div style={{ textAlign: 'right' }}>
                <span style={{ background: '#0B2C5F', color: '#fff', padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: 700 }}>{modulesTransversaux.reduce((s, m) => s + (m.hours || 0), 0)}h</span>
              </div>
            </div>
          </div>
        </section>
      )}

      {tab === "seminaires" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #dc2626, #ef4444)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Cours-Séminaires</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>12 thématiques • Approche interactive • Débats et cas pratiques</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '28px' }}>
            Les cours-séminaires visent à approfondir certaines thématiques liées au fonctionnement du système judiciaire.
            Ils reposent sur une approche interactive fondée sur les échanges d'expériences et l'analyse de cas pratiques.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
            {[
              'Justice et Presse', 'Le droit des détenus', "L'indisponibilité du corps humain",
              'La fonction sociale de la Justice des Mineurs', "L'avocat et le magistrat : Quelle relation?",
              'La Sanction pénale', "L'acte de juger", "La liberté d'expression doit-elle avoir une limite?",
              'Les paradis fiscaux', 'Les marchés publics', 'Procédure et habéas corpus', 'Communication judiciaire'
            ].map((topic, i) => (
              <div key={i} style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                transition: 'all 0.2s ease',
                cursor: 'default'
              }}
                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#0B2C5F'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(11,44,95,0.08)'; }}
                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: `hsl(${i * 30}, 60%, 95%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '14px', fontWeight: 800, color: '#0B2C5F' }}>
                  {i + 1}
                </div>
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>{topic}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {tab === "calendrier" && (
        <section className="ema-block">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px', marginBottom: '28px' }}>
            <div>
              <h2 className="ema-h3" style={{ marginBottom: '8px' }}>Calendrier académique</h2>
              <p className="ema-paragraph" style={{ margin: 0 }}>
                Promotion 8 — Parcours complet de juillet 2025 à mars 2027
              </p>
            </div>
            <a
              className="ema-btn ema-btn-primary"
              href="/documents/Formation Initiale.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Télécharger le PDF
            </a>
          </div>

          {/* Visual Calendar */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0', position: 'relative' }}>
            {/* Timeline line */}
            <div style={{ position: 'absolute', left: '23px', top: '24px', bottom: '24px', width: '2px', background: 'linear-gradient(to bottom, #0B2C5F, #D4AF37, #0B2C5F)', borderRadius: '2px' }} />

            {calendrier.map((e, idx) => {
              const isVacation = e.label.toLowerCase().includes('vacances');
              const isExam = e.label.toLowerCase().includes('épreuve') || e.label.toLowerCase().includes('examen');
              const isStage = e.label.toLowerCase().includes('stage');
              const isGraduation = e.label.toLowerCase().includes('graduation');
              const isCours = e.label.toLowerCase().includes('cours');

              let accentColor = '#0B2C5F';
              let bgColor = '#fff';
              let badgeLabel = '';
              if (isVacation) { accentColor = '#6B7280'; bgColor = '#f9fafb'; badgeLabel = 'Pause'; }
              else if (isExam) { accentColor = '#dc2626'; bgColor = '#fef2f2'; badgeLabel = 'Examen'; }
              else if (isStage) { accentColor = '#7c3aed'; bgColor = '#f5f3ff'; badgeLabel = 'Stage'; }
              else if (isGraduation) { accentColor = '#D4AF37'; bgColor = '#fffbeb'; badgeLabel = 'Cérémonie'; }
              else if (isCours) { accentColor = '#0B2C5F'; bgColor = '#eff6ff'; badgeLabel = 'Cours'; }

              return (
                <div key={idx} style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', paddingLeft: '0', marginBottom: '4px', position: 'relative' }}>
                  {/* Dot */}
                  <div style={{ position: 'relative', zIndex: 2, marginTop: '18px' }}>
                    <div style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      background: accentColor,
                      border: '3px solid #fff',
                      boxShadow: `0 0 0 2px ${accentColor}40`,
                      marginLeft: '18px'
                    }} />
                  </div>

                  {/* Card */}
                  <div style={{
                    flex: 1,
                    background: bgColor,
                    border: `1px solid ${accentColor}20`,
                    borderLeft: `4px solid ${accentColor}`,
                    borderRadius: '12px',
                    padding: '16px 20px',
                    marginBottom: '12px',
                    transition: 'all 0.2s ease',
                    cursor: 'default'
                  }}
                    onMouseOver={(ev) => { ev.currentTarget.style.transform = 'translateX(4px)'; ev.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; }}
                    onMouseOut={(ev) => { ev.currentTarget.style.transform = 'translateX(0)'; ev.currentTarget.style.boxShadow = 'none'; }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', flexWrap: 'wrap', gap: '8px' }}>
                      <span style={{ fontSize: '12px', fontWeight: 700, color: accentColor, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{e.date}</span>
                      {badgeLabel && (
                        <span style={{ fontSize: '10px', fontWeight: 700, color: accentColor, background: `${accentColor}15`, padding: '3px 10px', borderRadius: '100px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          {badgeLabel}
                        </span>
                      )}
                    </div>
                    <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '15px', marginBottom: '4px' }}>{e.label}</div>
                    {e.lieu !== "—" && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#6B7280' }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                        </svg>
                        {e.lieu}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Legend */}
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '24px', padding: '16px 20px', background: '#f9fafb', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <span style={{ fontSize: '12px', fontWeight: 600, color: '#374151', marginRight: '8px' }}>Légende :</span>
            <LegendItem color="#0B2C5F" label="Cours" />
            <LegendItem color="#7c3aed" label="Stage" />
            <LegendItem color="#dc2626" label="Examen" />
            <LegendItem color="#D4AF37" label="Cérémonie" />
            <LegendItem color="#6B7280" label="Pause" />
          </div>
        </section>
      )}

      {tab === "professoral" && (
        <section className="ema-block">
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #0B2C5F, #1e40af)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#0B2C5F', margin: 0 }}>Corps professoral</h2>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: '4px 0 0' }}>{profs.length} formateurs • Magistrats, avocats et universitaires</p>
            </div>
          </div>

          <p className="ema-paragraph" style={{ marginBottom: '28px' }}>
            Les enseignements sont assurés par un corps professoral composé de magistrats,
            avocats, professeurs d'université et experts spécialisés dans les différents
            domaines du droit.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
            {profs.map((p, i) => (
              <div key={p.name} style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                transition: 'all 0.3s ease',
                cursor: 'default'
              }}
                onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(11,44,95,0.08)'; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)'; }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: `hsl(${(i * 37) % 360}, 45%, 92%)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 800,
                    color: '#0B2C5F',
                    flexShrink: 0
                  }}>
                    {p.name.charAt(0).toUpperCase()}{p.name.split(' ').pop().charAt(0).toUpperCase()}
                  </div>
                  <div style={{ fontWeight: 700, color: '#0B2C5F', fontSize: '15px', lineHeight: 1.3 }}>{p.name}</div>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  {p.tags.slice(0, 2).map((t) => (
                    <span key={t} style={{ background: 'rgba(11,44,95,0.06)', color: '#0B2C5F', padding: '4px 10px', borderRadius: '100px', fontSize: '11px', fontWeight: 600 }}>
                      {t}
                    </span>
                  ))}
                </div>
                <div style={{ fontSize: '13px', color: '#6B7280', lineHeight: 1.6 }}>
                  {p.bio}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </PageShell>
  );
}

function Tab({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        padding: '12px 20px',
        fontSize: '14px',
        fontWeight: active ? 700 : 500,
        color: active ? '#0B2C5F' : '#6B7280',
        background: 'transparent',
        border: 'none',
        borderBottom: active ? '3px solid #0B2C5F' : '3px solid transparent',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginBottom: '-2px'
      }}
    >
      {children}
    </button>
  );
}

function LegendItem({ color, label }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: color }} />
      <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: 500 }}>{label}</span>
    </div>
  );
}
